<ll-titulo>Editar Asignatura evaluacion tipos</ll-titulo>
<ll-toolnavbar>
    <asignatura-evaluacion-tipos-toolnavbar [displayButtons]="'all'"></asignatura-evaluacion-tipos-toolnavbar>
</ll-toolnavbar>

<asignatura-evaluacion-tipos-edit
    [asignaturaEvaluacionTipoId]="asignaturaEvaluacionTipoId"
></asignatura-evaluacion-tipos-edit>
